/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_2_PInputs */

const en_cp_cmp_2_p = /** @type {(inputs: Cp_Cmp_2_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangkit · MSIB · Apple Developer Academy`)
};

const id_cp_cmp_2_p = /** @type {(inputs: Cp_Cmp_2_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangkit · MSIB · Apple Developer Academy`)
};

/**
* | output |
* | --- |
* | "Bangkit · MSIB · Apple Developer Academy" |
*
* @param {Cp_Cmp_2_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_2_p = /** @type {((inputs?: Cp_Cmp_2_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_2_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_2_p(inputs)
	return en_cp_cmp_2_p(inputs)
});